// extracted by mini-css-extract-plugin
export default {"box":"Toast_box__iC-zl","tick":"Toast_tick__kRTE+","content":"Toast_content__D7pB8","btn":"Toast_btn__DgSrH"};